// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── tokens ──────────────────────────────────────────────── */
:root {
  --am-blue: #2a71ff;
  --am-blue-light: #e8f0ff;
  --am-amber: #f59e0b;
  --am-amber-light: #fffbeb;
  --am-slate-50: #f8fafc;
  --am-slate-100: #f1f5f9;
  --am-slate-200: #e2e8f0;
  --am-slate-500: #64748b;
  --am-slate-900: #0f172a;
  --am-white: #ffffff;
  --am-radius-option: 22px;
  --am-radius-icon: 18px;
  --am-shadow-pos: 0 14px 34px rgba(42, 113, 255, 0.14);
  --am-shadow-kds: 0 14px 34px rgba(251, 191, 36, 0.14);
}

/* ── root shell ──────────────────────────────────────────── */
.am-root {
  height: 100vh;
  overflow: hidden;
  padding: 16px;
  gap: 16px;
  background: #ffffff;
  color: var(--am-slate-900);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

@media (min-width: 1024px) {
  .am-root { padding: 20px; gap: 20px; }
}

/* ── header card (standalone) ────────────────────────────── */
.am-header-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid var(--am-slate-200);
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  flex-shrink: 0;
}

/* ── header ──────────────────────────────────────────────── */
.am-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
}

@media (min-width: 1024px) {
  .am-header { padding: 12px 32px; }
}

.am-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* back button */
.am-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 9999px;
  border: 1px solid var(--am-slate-200);
  background: var(--am-white);
  color: var(--am-slate-500);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.am-back-btn:hover { background: var(--am-slate-50); color: var(--am-slate-900); }

/* logo */
.am-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .am-logo { height: 32px; }
}

/* step badge */
.am-step-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 9999px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--am-blue);
}

/* ── main ────────────────────────────────────────────────── */
.am-main {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  padding: 4px 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

/* ── inner card (flat — no border/shadow, just centering) ── */
.am-card {
  margin: 24px auto 0;
  width: 100%;
  max-width: 800px;
  padding: 0 4px;
  box-sizing: border-box;
}

/* ── card heading ────────────────────────────────────────── */
.am-card-heading {
  margin-bottom: 24px;
}

.am-eyebrow {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--am-blue);
  margin: 0;
}

.am-title {
  margin: 6px 0 0;
  font-size: 1.5rem;
  font-weight: 900;
  letter-spacing: -0.025em;
  color: var(--am-slate-900);
  line-height: 1.2;
}

@media (min-width: 1024px) {
  .am-title { font-size: 1.75rem; }
}

.am-subtitle {
  margin: 6px 0 0;
  font-size: 0.875rem;
  color: var(--am-slate-500);
}

/* ── options grid ────────────────────────────────────────── */
.am-options-grid {
  display: grid;
  gap: 14px;
}

@media (min-width: 640px) {
  .am-options-grid { grid-template-columns: 1fr 1fr; }
}

/* ── option button (shared) ──────────────────────────────── */
.am-option-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  border-radius: var(--am-radius-option);
  border: 1.5px solid var(--am-slate-200);
  background: var(--am-white);
  padding: 1.25rem;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

/* keyboard focus */
.am-option-pos.am-kb-focused {
  border-color: var(--am-blue);
  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);
  box-shadow: var(--am-shadow-pos), 0 0 0 3px rgba(42, 113, 255, 0.12);
  outline: 2px solid var(--am-blue);
  outline-offset: 2px;
}

.am-option-pos.am-kb-focused .am-option-title { color: var(--am-blue); }

.am-option-kds.am-kb-focused {
  border-color: var(--am-amber);
  background: linear-gradient(145deg, #fffdf7 0%, #ffffff 100%);
  box-shadow: var(--am-shadow-kds), 0 0 0 3px rgba(245, 158, 11, 0.12);
  outline: 2px solid var(--am-amber);
  outline-offset: 2px;
}

.am-option-kds.am-kb-focused .am-option-title { color: #d97706; }

/* POS hover */
.am-option-pos:hover {
  border-color: var(--am-blue);
  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);
  box-shadow: var(--am-shadow-pos);
}

.am-option-pos:hover .am-option-title { color: var(--am-blue); }

/* KDS hover */
.am-option-kds:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.am-option-kds:hover:not(:disabled) {
  border-color: var(--am-amber);
  background: linear-gradient(145deg, #fffdf7 0%, #ffffff 100%);
  box-shadow: var(--am-shadow-kds);
}

.am-option-kds:hover:not(:disabled) .am-option-title { color: #d97706; }

/* icons */
.am-option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 4rem;
  flex-shrink: 0;
  border-radius: var(--am-radius-icon);
}

.am-option-icon--pos { background: var(--am-blue-light); color: var(--am-blue); }
.am-option-icon--kds { background: var(--am-amber-light); color: var(--am-amber); }

/* option text */
.am-option-title {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--am-slate-900);
  transition: color 0.2s;
}

.am-option-desc {
  margin: 0.375rem 0 0;
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--am-slate-500);
}

/* footer note */
.am-note {
  margin-top: 20px;
  padding: 12px 16px;
  background: var(--am-slate-50);
  border-radius: 14px;
}

.am-note p {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--am-slate-500);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/AccessMode/AccessMode.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,+EAA+E;EAC/E,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW,aAAa,EAAE,SAAS,EAAE;AACvC;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa,kBAAkB,EAAE;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;AAC3C;;AAEA,qBAAqB,8BAA8B,EAAE,0BAA0B,EAAE;;AAEjF,SAAS;AACT;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW,YAAY,EAAE;AAC3B;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY,kBAAkB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB,8BAA8B,EAAE;AACrD;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,6DAA6D;EAC7D,oEAAoE;EACpE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,gDAAgD,qBAAqB,EAAE;;AAEvE;EACE,6BAA6B;EAC7B,6DAA6D;EAC7D,oEAAoE;EACpE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,gDAAgD,cAAc,EAAE;;AAEhE,cAAc;AACd;EACE,4BAA4B;EAC5B,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA,wCAAwC,qBAAqB,EAAE;;AAE/D,cAAc;AACd;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA,uDAAuD,cAAc,EAAE;;AAEvE,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,oCAAoC;AACtC;;AAEA,uBAAuB,gCAAgC,EAAE,qBAAqB,EAAE;AAChF,uBAAuB,iCAAiC,EAAE,sBAAsB,EAAE;;AAElF,gBAAgB;AAChB;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":["/* ── tokens ──────────────────────────────────────────────── */\n:root {\n  --am-blue: #2a71ff;\n  --am-blue-light: #e8f0ff;\n  --am-amber: #f59e0b;\n  --am-amber-light: #fffbeb;\n  --am-slate-50: #f8fafc;\n  --am-slate-100: #f1f5f9;\n  --am-slate-200: #e2e8f0;\n  --am-slate-500: #64748b;\n  --am-slate-900: #0f172a;\n  --am-white: #ffffff;\n  --am-radius-option: 22px;\n  --am-radius-icon: 18px;\n  --am-shadow-pos: 0 14px 34px rgba(42, 113, 255, 0.14);\n  --am-shadow-kds: 0 14px 34px rgba(251, 191, 36, 0.14);\n}\n\n/* ── root shell ──────────────────────────────────────────── */\n.am-root {\n  height: 100vh;\n  overflow: hidden;\n  padding: 16px;\n  gap: 16px;\n  background: #ffffff;\n  color: var(--am-slate-900);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n@media (min-width: 1024px) {\n  .am-root { padding: 20px; gap: 20px; }\n}\n\n/* ── header card (standalone) ────────────────────────────── */\n.am-header-card {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid var(--am-slate-200);\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  flex-shrink: 0;\n}\n\n/* ── header ──────────────────────────────────────────────── */\n.am-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n}\n\n@media (min-width: 1024px) {\n  .am-header { padding: 12px 32px; }\n}\n\n.am-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* back button */\n.am-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 9999px;\n  border: 1px solid var(--am-slate-200);\n  background: var(--am-white);\n  color: var(--am-slate-500);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.am-back-btn:hover { background: var(--am-slate-50); color: var(--am-slate-900); }\n\n/* logo */\n.am-logo {\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .am-logo { height: 32px; }\n}\n\n/* step badge */\n.am-step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 9999px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--am-blue);\n}\n\n/* ── main ────────────────────────────────────────────────── */\n.am-main {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  flex-direction: column;\n  padding: 4px 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n\n/* ── inner card (flat — no border/shadow, just centering) ── */\n.am-card {\n  margin: 24px auto 0;\n  width: 100%;\n  max-width: 800px;\n  padding: 0 4px;\n  box-sizing: border-box;\n}\n\n/* ── card heading ────────────────────────────────────────── */\n.am-card-heading {\n  margin-bottom: 24px;\n}\n\n.am-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--am-blue);\n  margin: 0;\n}\n\n.am-title {\n  margin: 6px 0 0;\n  font-size: 1.5rem;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n  color: var(--am-slate-900);\n  line-height: 1.2;\n}\n\n@media (min-width: 1024px) {\n  .am-title { font-size: 1.75rem; }\n}\n\n.am-subtitle {\n  margin: 6px 0 0;\n  font-size: 0.875rem;\n  color: var(--am-slate-500);\n}\n\n/* ── options grid ────────────────────────────────────────── */\n.am-options-grid {\n  display: grid;\n  gap: 14px;\n}\n\n@media (min-width: 640px) {\n  .am-options-grid { grid-template-columns: 1fr 1fr; }\n}\n\n/* ── option button (shared) ──────────────────────────────── */\n.am-option-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  border-radius: var(--am-radius-option);\n  border: 1.5px solid var(--am-slate-200);\n  background: var(--am-white);\n  padding: 1.25rem;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n/* keyboard focus */\n.am-option-pos.am-kb-focused {\n  border-color: var(--am-blue);\n  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);\n  box-shadow: var(--am-shadow-pos), 0 0 0 3px rgba(42, 113, 255, 0.12);\n  outline: 2px solid var(--am-blue);\n  outline-offset: 2px;\n}\n\n.am-option-pos.am-kb-focused .am-option-title { color: var(--am-blue); }\n\n.am-option-kds.am-kb-focused {\n  border-color: var(--am-amber);\n  background: linear-gradient(145deg, #fffdf7 0%, #ffffff 100%);\n  box-shadow: var(--am-shadow-kds), 0 0 0 3px rgba(245, 158, 11, 0.12);\n  outline: 2px solid var(--am-amber);\n  outline-offset: 2px;\n}\n\n.am-option-kds.am-kb-focused .am-option-title { color: #d97706; }\n\n/* POS hover */\n.am-option-pos:hover {\n  border-color: var(--am-blue);\n  background: linear-gradient(145deg, #f0f5ff 0%, #ffffff 100%);\n  box-shadow: var(--am-shadow-pos);\n}\n\n.am-option-pos:hover .am-option-title { color: var(--am-blue); }\n\n/* KDS hover */\n.am-option-kds:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.am-option-kds:hover:not(:disabled) {\n  border-color: var(--am-amber);\n  background: linear-gradient(145deg, #fffdf7 0%, #ffffff 100%);\n  box-shadow: var(--am-shadow-kds);\n}\n\n.am-option-kds:hover:not(:disabled) .am-option-title { color: #d97706; }\n\n/* icons */\n.am-option-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 4rem;\n  width: 4rem;\n  flex-shrink: 0;\n  border-radius: var(--am-radius-icon);\n}\n\n.am-option-icon--pos { background: var(--am-blue-light); color: var(--am-blue); }\n.am-option-icon--kds { background: var(--am-amber-light); color: var(--am-amber); }\n\n/* option text */\n.am-option-title {\n  margin: 0;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: var(--am-slate-900);\n  transition: color 0.2s;\n}\n\n.am-option-desc {\n  margin: 0.375rem 0 0;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  color: var(--am-slate-500);\n}\n\n/* footer note */\n.am-note {\n  margin-top: 20px;\n  padding: 12px 16px;\n  background: var(--am-slate-50);\n  border-radius: 14px;\n}\n\n.am-note p {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--am-slate-500);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
